import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-header" }
const _hoisted_2 = { class: "offcanvas-title" }
const _hoisted_3 = { class: "offcanvas-body" }

import { onMounted, ref, watch } from 'vue';
  import { Offcanvas } from 'bootstrap';

  export interface IProps {
    modelValue: boolean;
    title?: string;
    placement?: string;
  }

  export interface IEmits {
    (event: 'update:modelValue', modelValue: boolean): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean },
    title: null,
    placement: { default: 'offcanvas-start' }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', modelValue: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, title?: string, placement: string }

  
  

  const root = ref();
  let offcanvas: Offcanvas;

  onMounted(
    () => {
      offcanvas = new Offcanvas(root.value);
      if (props.modelValue) {
        offcanvas.show();
      }
      watch(
        () => props.modelValue,
        (val) => offcanvas[val ? 'show' : 'hide']()
      );
    }
  );

  const handleToggle = () => {
    emits('update:modelValue', !props.modelValue);
  };

  const on = {
    'hide.bs.offcanvas': () => {
      emits('update:modelValue', false);
    }
  };


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "root",
    ref: root,
    class: ["offcanvas", [__props.placement]]
  }, _toHandlers(on)), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(__props.title), 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn-close text-reset",
        onClick: handleToggle
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 16))
}
}

})